export const name = "SHA1";
export const summary = `Computes the hash of a \`STRING\` or \`BYTES\` value, using the SHA-1 algorithm.`;
export const reference = `
## SHA1

Computes the hash of a \`STRING\` or \`BYTES\` value, using the SHA-1 algorithm.

\`\`\`
SHA1(input)
\`\`\`

### Description

Computes the hash of the input using the SHA-1 algorithm. The input can either be\`STRING\` or \`BYTES\`. The string version treats the input as an array of bytes.

This function returns 20 bytes.


### Warning: SHA1 is no longer considered secure.
For increased security, use another hashing function.




### Return type

\`BYTES\`


### Example



\`\`\`
SELECT SHA1("Hello World") as sha1;

-- Note that the result of SHA1 is of type BYTES, displayed as a base64-encoded string.
/*------------------------------*
 | sha1 |
 +------------------------------+
 | Ck1VqNd45QIvq3AZd8XYQLvEhtA= |
 *------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/hash_functions
`;
